export const INSURANCE_TAB = {
  Increase: 'increase',
  Decrease: 'decrease',
  Waiting: 'waiting-for-approved',
  Participant: 'participant',
  Recordpayment: 'recordpayment',
  RecordPaymentYear: 'recordPaymentYear',
};
